function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Avatar } from '../../Avatar';
import { ENTER_KEY, SPACE_KEYCODE } from '../../Utils/constant';
import CollapsableList from '../CollapsableList/CollapsableList';
import HelpText from '../CommonComponents/HelpText/HelpText';
import { DropdownContext } from '../context';
import { OptionTypes } from '../helper';
import { searchedText, generateItemKey } from '../helper';
import SectionList from '../SectionList/SectionList';
import styles from '@dtsl/css-dropdown/dist/index.module.css';
import Lock from '@dtsl/icons/dist/icons/react/Lock';
function SingleSelectionList(props) {
  let {
    options,
    onSelect,
    noOptionContent,
    isDropdownButton
  } = props;
  const {
    setIsOpen,
    setIsOverlayOpen,
    selectedValues,
    setSelectedValues,
    isMobile,
    searchValue,
    setSearchValue
  } = useContext(DropdownContext);
  options = searchedText(searchValue, [...options]);
  const setValue = (selectedObj, event) => {
    event.nativeEvent.stopImmediatePropagation();
    setSearchValue('');
    fireChangeEvent(selectedObj, event);
    !isDropdownButton && setSelectedValues([selectedObj]);
    isMobile ? setIsOverlayOpen(false) : setIsOpen(false);
  };
  const fireChangeEvent = (selectedObj, event) => {
    if (selectedObj !== (selectedValues[0] || {}) && onSelect) {
      onSelect(selectedObj, event); // pass event too
    }
  };
  const onFolderMouseOver = event => {
    event.stopPropagation();
    event.preventDefault();
    const dropdownWrapper = event.target.closest('#sib-dropdown-id');
    Array.from(dropdownWrapper.getElementsByClassName(styles['sib-dropdown-option-group'])).forEach(parentNode => {
      Array.from(parentNode.querySelector('#sib-dropdown-option-group-content-id').children).forEach(node => {
        node.classList.remove(styles['is-hovered']);
      });
    });
  };
  const onSectionMouseOver = event => {
    event.stopPropagation();
    event.preventDefault();
    const dropdownWrapper = event.target.closest('#sib-dropdown-id');
    Array.from(dropdownWrapper.getElementsByClassName(styles['sib-dropdown-option-section-header'])).forEach(parentNode => {
      Array.from(parentNode.querySelector('#sib-dropdown-option-section-header-content-id').children).forEach(node => {
        node.classList.remove(styles['is-hovered']);
      });
    });
  };
  const onMouseOver = event => {
    event.stopPropagation();
    event.preventDefault();
    const dropdownWrapper = event.target.closest('#sib-dropdown-id');
    const menu = dropdownWrapper.querySelector('#sib-dropdown-menu-id');
    Array.from(menu.children).forEach(node => {
      node.classList.remove(styles['is-hovered']);
    });
  };
  const getMouseOverFunc = optionType => {
    if (optionType === OptionTypes.COLLAPSABLE_LIST) {
      return onFolderMouseOver;
    }
    if (optionType === OptionTypes.SECTION_LIST) {
      return onSectionMouseOver;
    }
    return onMouseOver;
  };
  const renderOption = (option, index, optionType) => {
    let {
      key = index,
      svg,
      label,
      value,
      isLink = false,
      target = '_self',
      disabled = false,
      addtionalInfo = () => {},
      helpText,
      highLightedLabel
    } = option;
    let isSelected = value === (selectedValues[0] || {}).value && label === (selectedValues[0] || {}).label;
    const optionClass = classNames({
      [styles['sib-dropdown-option']]: true,
      [styles['is-hovered']]: isSelected,
      [styles['locked']]: disabled,
      [option.className]: !!option.className
    });
    const primaryInfoClass = classNames({
      [styles['primary-info']]: true,
      [styles['is-selected']]: isSelected,
      [styles['sib-remove-bottomspace']]: !helpText
    });
    const addInfo = addtionalInfo();
    if (option?.isAvatar) {
      const {
        name,
        label,
        helpText,
        disabled,
        ...restAvatarProps
      } = option;
      return /*#__PURE__*/React.createElement("li", {
        key: key || label || value,
        className: optionClass,
        onClick: !disabled ? event => setValue(option, event) : null,
        onKeyDown: event => {
          if ((event.key === ENTER_KEY || event.keyCode === SPACE_KEYCODE) && !disabled) {
            setValue(option, event);
          }
        },
        role: "option",
        "aria-selected": isSelected ? 'true' : 'false',
        onFocus: getMouseOverFunc(optionType)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['sib-dropdown-option__content--with-avatar'],
        disabled: disabled
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['sib-dropdown-option__content-left']
      }, /*#__PURE__*/React.createElement("div", {
        className: primaryInfoClass
      }, /*#__PURE__*/React.createElement(Avatar, _extends({
        label: label,
        type: "initial",
        status: "inactive"
      }, restAvatarProps)))), /*#__PURE__*/React.createElement("div", {
        className: styles['sib-dropdown-option__avatar-label']
      }, name ? name : null, helpText && /*#__PURE__*/React.createElement(HelpText, {
        svg: svg,
        helpText: helpText
      }))));
    }
    return /*#__PURE__*/React.createElement("li", {
      key: key || label || value,
      className: optionClass,
      onClick: !disabled ? event => setValue(option, event) : null,
      onKeyDown: event => {
        if ((event.key === ENTER_KEY || event.keyCode === SPACE_KEYCODE) && !disabled) {
          setValue(option, event);
        }
      },
      role: "option",
      "aria-selected": isSelected ? 'true' : 'false',
      onFocus: getMouseOverFunc(optionType)
    }, isLink ? /*#__PURE__*/React.createElement("a", _extends({}, !disabled ? {
      href: value || '#'
    } : {}, {
      title: label,
      target: target,
      className: styles['sib-dropdown-option__content'],
      disabled: disabled
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['sib-dropdown-option__content-left']
    }, /*#__PURE__*/React.createElement("span", {
      className: primaryInfoClass
    }, disabled ? /*#__PURE__*/React.cloneElement(/*#__PURE__*/React.createElement(Lock, null), {
      className: styles['sib-dropdown-option__icon']
    }) : svg ? /*#__PURE__*/React.cloneElement(svg, {
      className: styles['sib-dropdown-option__icon']
    }) : null, searchValue ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: highLightedLabel
      }
    }) : label), helpText && /*#__PURE__*/React.createElement(HelpText, {
      svg: svg,
      helpText: helpText
    })), addInfo ? /*#__PURE__*/React.createElement("span", {
      className: styles['additional-info']
    }, addInfo) : null) : /*#__PURE__*/React.createElement("div", {
      title: label,
      className: styles['sib-dropdown-option__content'],
      disabled: disabled
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['sib-dropdown-option__content-left']
    }, /*#__PURE__*/React.createElement("span", {
      className: primaryInfoClass
    }, svg ? disabled ? /*#__PURE__*/React.cloneElement(/*#__PURE__*/React.createElement(Lock, null), {
      className: styles['sib-dropdown-option__icon']
    }) : /*#__PURE__*/React.cloneElement(svg, {
      className: styles['sib-dropdown-option__icon']
    }) : null, searchValue ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: highLightedLabel
      }
    }) : label), helpText && /*#__PURE__*/React.createElement(HelpText, {
      svg: svg,
      helpText: helpText
    })), addInfo ? /*#__PURE__*/React.createElement("span", {
      className: styles['additional-info']
    }, addInfo) : null));
  };
  let ops = options.map((option, index) => {
    const {
      type
    } = option || {};
    if (type === OptionTypes.COLLAPSABLE_LIST) {
      let _options = option.items.map((item, idx) => renderOption(item, item?.key || generateItemKey(index, idx), option.type));
      return /*#__PURE__*/React.createElement(CollapsableList, {
        key: option.name,
        index: index,
        heading: option.name,
        defaultOpen: true
      }, _options);
    } else if (option.type === OptionTypes.SECTION_LIST) {
      let _options = option.items.map((item, idx) => renderOption(item, idx, option.type));
      return /*#__PURE__*/React.createElement(SectionList, {
        key: option.name || index,
        heading: option.name,
        defaultOpen: true
      }, _options);
    } else {
      return renderOption(option, index);
    }
  });
  return ops.length ? ops : /*#__PURE__*/React.createElement("li", {
    className: `${styles['sib-dropdown-option']} ${styles['sib-dropdown-no_option']}`,
    role: "option",
    tabIndex: "0",
    "aria-selected": "false"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-dropdown-option__content']
  }, noOptionContent));
}
SingleSelectionList.defaultProps = {
  options: [],
  isLoading: false,
  onSelect: () => {},
  isDropdownButton: false,
  noOptionContent: 'No options to select'
};
SingleSelectionList.propTypes = {
  isLoading: PropTypes.bool,
  onSelect: PropTypes.func,
  noOptionContent: PropTypes.string,
  isDropdownButton: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    value: PropTypes.any,
    svg: PropTypes.node,
    addtionalInfo: () => {},
    helpText: PropTypes.string
  }))
};
export default SingleSelectionList;